import { createFileRoute } from "@tanstack/react-router";
import { AssessmentStart } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/assessment/start")({
  head: () => seoHead({ title: "Start Your LeadXkids Assessment", description: "Confirm parent consent and continue your Know Your Child Assessment with your existing access or Annual Membership.", noindex: true }),
  component: AssessmentStart,
});
